// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
li[data-v-3979686a] {
    margin-bottom: 0.5em;
    margin-inline-start: 1.25em;
}
li .title[data-v-3979686a] {
    margin-bottom: 0;
    color: var(--color-main-text);
    font-weight: bolder;
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeView/RecipeNutritionInfoItem.vue"],"names":[],"mappings":";AA+BA;IACA,oBAAA;IACA,2BAAA;AACA;AAEA;IACA,gBAAA;IACA,6BAAA;IACA,mBAAA;AACA","sourcesContent":["<template>\n    <li>\n        <div class=\"title\">\n            {{ title }}\n        </div>\n        <div class=\"data\">\n            {{ data }}\n        </div>\n    </li>\n</template>\n\n<script setup>\ndefineProps({\n    title: {\n        type: String,\n        required: true,\n    },\n    data: {\n        type: String,\n        required: true,\n    },\n});\n</script>\n\n<script>\nexport default {\n    name: 'RecipeNutritionInfoItem',\n};\n</script>\n\n<style scoped>\nli {\n    margin-bottom: 0.5em;\n    margin-inline-start: 1.25em;\n}\n\nli .title {\n    margin-bottom: 0;\n    color: var(--color-main-text);\n    font-weight: bolder;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
